// extracted by mini-css-extract-plugin
export default {"tooltip":"ArticleSinglePriceCell_tooltip__PGDkf","highlight":"ArticleSinglePriceCell_highlight__5kEIk"};